module.exports = __webpack_public_path__ + "static/Rhapsody-aa6af219d90520f38b9f4ce789a74d15.mp3";